export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => (
  <div className={className} {...rest}>
    {children}
  </div>
);

export const Eyebrow = ({ children, className = "" }) => (
  <p
    className={`text-[11px] font-semibold uppercase tracking-[0.3em] text-gold ${className}`}
  >
    {children}
  </p>
);

export const GoldButton = ({ as: Tag = "a", children, className = "", ...rest }) => (
  <Tag
    className={`inline-flex items-center justify-center gap-2.5 rounded-md bg-gold px-7 py-3 text-[12px] font-semibold uppercase tracking-[0.16em] text-noir transition-colors duration-300 hover:bg-[#D3A45C] ${className}`}
    {...rest}
  >
    {children}
  </Tag>
);

export const GhostButton = ({ as: Tag = "a", children, className = "", ...rest }) => (
  <Tag
    className={`inline-flex items-center justify-center gap-2.5 rounded-md border border-gold/70 px-7 py-3 text-[12px] font-semibold uppercase tracking-[0.16em] text-gold transition-colors duration-300 hover:bg-gold hover:text-noir ${className}`}
    {...rest}
  >
    {children}
  </Tag>
);
